import React, { useEffect, useRef } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { UNAUTHENTICATED_PATHS } from '../../constants';
import { useAppContext } from '../../hooks/AppContext';
import { useCreateNavigationEventMutation } from '../../types/api.graphql';

export default function AuthenticatedRoute() {
  const { pathname, search } = useLocation();
  const { isAuthenticated } = useAppContext();
  const previousLocation = useRef<string>(null);
  const [createNavigationEvent] = useCreateNavigationEventMutation();

  useEffect(() => {
    void createNavigationEvent({
      variables: {
        input: {
          toPathname: pathname,
          fromPathname: previousLocation.current,
        },
      },
    });
    if (pathname !== previousLocation.current) {
      previousLocation.current = pathname;
    }
  }, [pathname]);

  const navigate = useNavigate();
  useEffect(() => {
    if (!isAuthenticated) {
      navigate(`${UNAUTHENTICATED_PATHS.Login}?redirect=${pathname}${search}`, { replace: true });
    }
  }, [isAuthenticated]);
  return <Outlet />;
}
